export const GET_BINDINGS = 'GET_BINDINGS';
export const BINDING_FETCH_SUCCESS = 'BINDING_FETCH_SUCCESS';
export const FAILED_BINDINGS = 'FAILED_BINDINGS';

export const ERROR_RECEIVED_FROM_API_BINDINGS = 'ERROR_RECEIVED_FROM_API_BINDINGS';
